import { WEBHOOK_LINKED_EMPTY_SUFFIX, WEBHOOK_LINKED_NONEMPTY_SUFFIX } from '../constants';
import type { WebhookProcessingTone } from './types';

/** Panel subtitle: `N linked · assignment pending|target state`. */
export const getWebhookPanelCountLabel = (count: number): string => {
  const safe = Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0;
  const suffix = safe === 0 ? WEBHOOK_LINKED_EMPTY_SUFFIX : WEBHOOK_LINKED_NONEMPTY_SUFFIX;
  return `${safe} linked · ${suffix}`;
};

export const getWebhookProcessingTone = (status: string | null | undefined): WebhookProcessingTone => {
  switch (status) {
    case 'fulfilled':
      return 'fulfilled';
    case 'error':
      return 'error';
    case 'ignored':
      return 'ignored';
    case 'processing':
      return 'processing';
    case 'received':
    default:
      return 'received';
  }
};
